export const OPLOG_PULSE_DURATION = 2; // seconds
export const OPLOG_PULSE_CYCLES = 60; // 2 seconds * 60 cycles = 120 seconds = 2 minutes
